import store from '@/store/store';

export default function getBounds() {
  const site = store.getters['user/site'];
  if (site === 'clg' || site === 'reunionaffichage' || site === 'aventi'
    || site === 'craffichage' || site === 'sra') {
    return {};
  }
  return {
    bounds: {
      south: 42.3,
      west: -5.394720000000007,
      north: 51.2,
      east: 8.600000000000023 },
    strictBounds: true,
  };
}




// WEBPACK FOOTER //
// ./src/services/general/getBounds.js